import axios, { Canceler } from 'axios';
import { format } from 'date-fns';

import { MDFeSearch } from '../interfaces/MDFe';

import { ConciergeMonitor, ConciergePost, ConciergePut, ConciergeSearch } from '../interfaces/Concierge';
import { DeliveryWindowDate, InfoConference100, InfoConference100InsertUpdate, InfoConference100Register, InfoMvmAddInvoices, InfoMvmAddOutgoingInvoice, InfoMvmAddOutgoingRequest, InfoMvmAddTransportOrder, InfoMvmShedCheckout, InfoMvmShedCheckoutUnload, MvmCriticalMaterialCallPut, MvmEKanbanSearch, MvmEntry, MvmExit, MvmInvoiceGet, MvmOutgoingInvoiceRequestSearch, MvmSchedule, MvmSearch, MvmShedAdd, MvmShedRequest, MvmShedStartLoadUnloadPut, MvmSubmit, MvnOutgoingMaterialInvoicePost } from '../interfaces/Mvm';
import { PackingFCMPost, PackingFCMSearch } from '../interfaces/PackingFcm';
import { ParameterSearch } from '../interfaces/Parameter';
import { getUrlMvmApi, getUrlReportApi } from '../utils/util';
import ApiHandler from './ApiHandler';

//export const baseURL = "https://localhost:5001";
export const baseURL = String(getUrlMvmApi(window));
export const reportURL = String(getUrlReportApi(window));

const cancelToken = axios.CancelToken;
let cancel: Canceler;

export default class MvmApi {

  static async searchMvm(params: MvmSearch) {
    let includePropParams = "";

    if (params.includeProperties && params.includeProperties?.length > 0)
      params.includeProperties?.forEach(prop => includePropParams += `includeProperties=${prop}`);

    var response = await ApiHandler(baseURL).get(`mvm/search?${includePropParams}`, { params });
    return response.data;
  }

  static async searchMvmNew(params: MvmSearch) {
    let includePropParams = "";

    if (params.includeProperties && params.includeProperties?.length > 0)
      params.includeProperties?.forEach(prop => includePropParams += `includeProperties=${prop}`);

    var response = await ApiHandler(baseURL).get(`mvm/searchNew?${includePropParams}`, { params });
    return response.data;
  }

  static async searchMvmNonCount(params: MvmSearch) {
    let includePropParams = "";

    if (params.includeProperties && params.includeProperties?.length > 0)
      params.includeProperties?.forEach(prop => includePropParams += `includeProperties=${prop}`);

    var response = await ApiHandler(baseURL).get(`mvm/searchMvmNonCount?${includePropParams}`, { params });
    return response.data;
  }

  static async UpdateDeliveryWindowDate(deliveryWindowDate: DeliveryWindowDate) {
    var response = await ApiHandler(baseURL).put('mvm/updatedeliverywindowdate', deliveryWindowDate);
    return response;
  }

  static async getMvm(mvmId: number, screen?: string, includeProperties?: string[]) {
    screen ??= '';
    const strIncludes = includeProperties?.map(prop => `includeProperties=${prop}`).join('&');

    //     includeProps: ["Invoices", "Sheds", "Suppliers", "OutgoingRequests", "Company"]
    var response = await ApiHandler(baseURL).get(`mvm?id=${mvmId}&screen=${screen}&${strIncludes}`);
    return response.data;
  }

  static async getMvmByMvmNumber(mvmNumber: string, plantId: any, includeProperties: string[]) {
    const strIncludes = includeProperties?.map(prop => `includeProperties=${prop}`).join('&');
    const response = await ApiHandler(baseURL).get(`mvm/mvmnumber/${mvmNumber}/${plantId ?? ''}?${strIncludes}`);
    return response.data;
  }

  static async getInvoiceData(mvmId: number, companyId: number, plantId: string, invoiceKey: string) {
    var response = await ApiHandler(baseURL).get(`mvm/get-invoice-data?mvmId=${mvmId}&companyId=${companyId}&plantId=${plantId}&key=${invoiceKey}`);
    return response;
  }

  static async getEntryAuthorizationMvm(plantId: number, userName: string) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get(`mvm/EntryAuthorizationMvmMonitorList?plantId=${plantId}&userName=${userName}`);
    return response.data;
  }

  static async getEntryAuthorizationCounts(plantId: number, userName: string, companyId: number) {

    if (cancel !== undefined) {
      cancel('cancelled-by-request');
    }

    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor'))
      .get(`mvm/EntryAuthorizationMvmMonitorCount?plantId=${plantId}&userName=${userName}&companyId=${companyId}`, {
        cancelToken: new cancelToken(c => {
          cancel = c;
        })
      });
    return response.data;
  }

  static async getPendingTransportOrder(plantId: number) {
    var response = await ApiHandler(baseURL).get(`mvm/pending-transport-order?plantId=${plantId}`);
    return response.data;
  }

  static async getVehicleStayTimeMonitor(plantId: number) {
    var response = await ApiHandler(baseURL).get(`monitor/vehicle-stay-time-monitor?plantId=${plantId}`);
    return response.data;
  }

  static async startPendingTransportOrder(mvmNumber: number) {
    var response = await ApiHandler(baseURL).post(`mvm/start-pending-transport-order/${mvmNumber}`);
    return response;
  }

  static async getShedsUserCheckInMvmMonitorList(plantId: number, userName: string) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get(`mvm/shedsusercheckinmvmmonitorlist?plantId=${plantId}&userName=${userName}`);
    return response.data;
  }

  static async getShedsUserMvmMonitorList(plantId: number, userName: string) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get(`mvm/shedsusermvmmonitorlist?plantId=${plantId}&userName=${userName}`);
    return response.data;
  }

  static async getShedsMvmMonitorList(plantId: number) {
    var response = await ApiHandler(baseURL).get(`mvm/ShedsMvmMonitorList?plantId=${plantId}`);
    return response.data;
  }

  static async getVehicleWatingNFList(plantId: number, userName: string) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get(`mvm/VehicleWaitingNF?plantId=${plantId}&userName=${userName}`);
    return response.data;
  }

  static async getSupplierTypes(supplierId: number, plantId: number, companyId: number) {
    var response = await ApiHandler(baseURL).get(`mvm/get-supplier-types?supplierId=${supplierId}&plantId=${plantId}&companyId=${companyId}`);
    return response.data;
  }

  static async getDriverData(params: MvmSearch) {
    var response = await ApiHandler(baseURL).get('mvm/getdriverinfo', { params });
    return response.data;
  }

  static async addMvmInvoices(data: InfoMvmAddInvoices) {
    var response = await ApiHandler(baseURL).put('mvm/addinvoice', data);
    return response;
  }

  static async searchMvmNumbersAutocomplete(companyId: string, mvmNumber: string, mvmStatus?: string[]) {

    const params = new URLSearchParams();
    params.append('companyId', companyId);
    params.append('pageIndex', '0');
    params.append('pageSize', '10');
    params.append('mvmNumber', mvmNumber.toString());
    params.append("sort", "updatedAt")
    params.append("sortDir", 'desc')
    mvmStatus?.forEach(status => params.append('statuses', status.toString()))

    var response = await ApiHandler(baseURL).get('mvm/search', { params });

    var resp: { code: any; label: any; }[] = []

    for (var i = 0; i < response.data.items.length; i++) {
      resp.push({ code: response.data.items[i].id, label: response.data.items[i].mvmNumber })
    }

    return resp
  }
  static async searchMvmNumbersNonCountAutocomplete(companyId: string, mvmNumber: string, mvmStatus?: string[]) {

    const params = new URLSearchParams();
    params.append('companyId', companyId);
    params.append('pageIndex', '0');
    params.append('pageSize', '10');
    params.append('mvmNumber', mvmNumber.toString());
    params.append("sort", "updatedAt")
    params.append("sortDir", 'desc')
    mvmStatus?.forEach(status => params.append('statuses', status.toString()))

    var response = await ApiHandler(baseURL).get('mvm/searchNonCount', { params });

    var resp: { code: any; label: any; }[] = []

    for (var i = 0; i < response.data.length; i++) {
      resp.push({ code: response.data[i].id, label: response.data[i].mvmNumber })
    }

    return resp
  }
  static async postMvm(data: MvmSubmit) {
    var response = await ApiHandler(baseURL).post('mvm', data);
    return response;
  }

  static async shedCheckin(mvmId: number, data: number[]) {
    var response = await ApiHandler(baseURL).put('mvm/shed-checkin', { Id: mvmId, MvmShedIds: data });
    return response;
  }

  static async entryMvm(data: MvmEntry) {
    var response = await ApiHandler(baseURL).put('mvm/entry-mvm', data);
    return response;
  }

  static async exitMvm(data: MvmExit) {
    var response = await ApiHandler(baseURL).put('mvm/exit-mvm', data);
    return response;
  }

  static async autoryzePlantEntry(data: any) {
    var response = await ApiHandler(baseURL).put('mvm/authorize-plant-entry', data);
    return response;
  }

  static async cancelAuthorizationPlantEntry(mvmId: number) {
    var response = await ApiHandler(baseURL).put(`mvm/cancel-authorization-plant-entry?mvmId=${mvmId}`);
    return response;
  }

  static async putMvm(data: MvmSubmit) {
    var response = await ApiHandler(baseURL).put('mvm', data);
    return response;
  }

  static async putFullMvm(data: MvmSubmit) {
    var response = await ApiHandler(baseURL).put('mvm/full', data);
    return response;
  }

  static async recordScheduleRack(data: MvmSchedule) {
    await ApiHandler(baseURL).put('mvm/recordScheduleRack', data);
  }

  static async shedsSave(data: MvmShedRequest) {
    var response = await ApiHandler(baseURL).post('mvm/save-sheds', data);
    return response;
  }

  static async addMvmOutgoingRequest(data: InfoMvmAddOutgoingRequest) {
    var response = await ApiHandler(baseURL).put('mvm/insertOutgoingRequest', data);
    return response;
  }

  static async getShedListById(mvmId: number) {
    var response = await ApiHandler(baseURL).get(`mvm/GetMvmShedsByMvmId/${mvmId}`);
    return response.data;
  }

  static async addMvmOutgoingInvoice(data: InfoMvmAddOutgoingInvoice) {
    var response = await ApiHandler(baseURL).put('mvm/insertOutgoingInvoice', data);
    return response;
  }

  static async searchTakenDeliveryWindows(companyId: string, shippingSupplierId: string, deliveryWindowDate: string) {
    var response = await ApiHandler(baseURL).get(`mvm/search-taken-delivery-windows?companyId=${companyId}&shippingSupplierId=${shippingSupplierId}&deliveryWindowDate=${deliveryWindowDate}`);
    return response.data;
  }

  static async exportRacks(mvmId: number) {
    var response = await ApiHandler(baseURL).put(`mvm/exportRacksToMDR?mvmId=${mvmId}`);
    return response;
  }

  static async SearchPendingInvoicing(companyId: string, plantId: number) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get(`mvm/search-pending-invoicing-V2`, { params: { companyId, plantId } });
    return response.data;
  }

  static async recordMvmShed(data: any) {
    var response = await ApiHandler(baseURL).put(`mvm/recordMvmShed`, data);
    return response.data;
  }


  static async finishRackLoad(data: InfoMvmShedCheckout) {
    var response = await ApiHandler(baseURL).put(`mvm/finish-rack-load-V2`, data);
    return response.data;
  }

  static async updateRackLoadBlockedUser(mvmId: number, companyId: number) {
    var response = await ApiHandler(baseURL).get(`mvm/update-rackload-blocked-user?mvmId=${mvmId}&companyId=${companyId}`);
    return response.data;
  }

  static async startShedLoadUnload(data: MvmShedStartLoadUnloadPut) {
    var response = await ApiHandler(baseURL).put(`mvm/startShedLoadUnload`, data);
    return response.data;
  }

  static async cancelStartShedLoadUnload(data: MvmShedStartLoadUnloadPut) {
    var response = await ApiHandler(baseURL).put(`mvm/cancelStartShedLoadUnload`, data);
    return response.data;
  }

  static async searchMvmOnConcierge(plantId: string) {
    var response = await ApiHandler(baseURL).get(`mvm/search-mvm-on-concierge`, { params: { plantId } });
    return response.data;
  }

  static async validateInvoicesInUse(data: any) {
    await ApiHandler(baseURL).post(`mvm/validate-invoices-in-use`, data);
  }

  static async CriticalMaterialCall(PlantId: string, invoiceSupplierId: string, partnumberCode: number) {
    var response = await ApiHandler(baseURL).get(`mvm/critical-material-call`, { params: { PlantId, invoiceSupplierId, partnumberCode } });
    return response.data;
  }

  static async CriticalMaterialCallPut(data: MvmCriticalMaterialCallPut) {
    var response = await ApiHandler(baseURL).put('mvm/critical-material-call-put', data);
    return response;
  }

  static async PendingAccountingMonitor(PlantId: string) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get(`mvm/pending-accounting`, { params: { PlantId } });
    return response.data;
  }

  static async PendingAccountingResolutionByDateMonitor(PlantId: string,  startDate: Date, endDate: Date, mvmNumber?: string) {
    var response = await ApiHandler(baseURL).get(`mvm/pending-accounting-resolution-by-date`, { params: { PlantId, startDate, endDate, mvmNumber } });
    return response.data;
  }

  static async finishRackUnload(data: InfoMvmShedCheckoutUnload) {
    var response = await ApiHandler(baseURL).put(`mvm/finish-material-unload`, data);
    return response.data;
  }

  static async addMvmTransportOrder(data: InfoMvmAddTransportOrder) {
    var response = await ApiHandler(baseURL).put(`mvm/savetransportorder`, data);
    return response.data;
  }

  static async getMonitor(plantId: string) {
    var response = await ApiHandler(baseURL).get(`monitor/mvm-monitor`, { params: { plantId } });
    return response.data;
  }

  static async getMonitorSumary(plantId: string) {
    var response = await ApiHandler(baseURL).get(`monitor/mvm-monitor-summary`, { params: { plantId } });
    return response.data;
  }

  static async getMonitorSheds(plantId: string) {
    var response = await ApiHandler(baseURL).get(`monitor/mvm-monitor-sheds`, { params: { plantId } });
    return response.data;
  }

  static async searchConference100(params: InfoConference100) {
    var response = await ApiHandler(baseURL).get('mvmconference/search', { params });
    return response.data;
  }

  static async searchOutgoingInvoice(params: MvmOutgoingInvoiceRequestSearch) {
    var response = await ApiHandler(baseURL).get('mvm/search-outgoing-invoice-request', { params });
    return response.data;
  }

  static async searchConference100ToRegister(params: InfoConference100Register) {
    var response = await ApiHandler(baseURL).get('mvmconference/search-conferences-to-register', { params });
    return response.data;
  }

  static async getConference100ToRegister(params: InfoConference100InsertUpdate) {
    var response = await ApiHandler(baseURL).get('mvmconference/get-conferences-to-register', { params });
    return response.data;
  }

  static async postConferences(params: any) {
    var response = await ApiHandler(baseURL).post('mvmconference', params);
    return response.data;
  }

  static async getMonitoringPanelMenu(plantId: string) {
    var response = await ApiHandler(baseURL).get('monitor/monitoring-panel-menu?plantId=' + plantId);
    return response.data;
  }

  static async getMonitoringPanel(params: any) {
    var response = await ApiHandler(baseURL).get('monitor/monitoring-panel', { params });
    return response.data;
  }

  static async verifyPlate(data: MvmSubmit) {
    var response = await ApiHandler(baseURL).post('mvm/plate-verify', data);
    return response;
  }

  static async getMvmOutgoingInvoiceRequest(id: any) {
    var response = await ApiHandler(baseURL).get('mvm/get-mvm-outgoing-invoice-request?id=' + id);
    return response.data;
  }

  static async createCorrectionMvmOutgoingInvoiceRequest(params: any) {
    await ApiHandler(baseURL).post('mvm/create-correction-mvm-outgoing-invoice-request/', params);
  }

  static async getResubmissionRequisitionList(plantId: number) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get(`mvm/ResubmissionRequisitionList?plantId=${plantId}`);
    return response.data;
  }

  static async saveAccountingPendingUserResolution(mvmId: string) {
    var response = await ApiHandler(baseURL).post('mvm/save-accounting-pending-user-resolution?mvmId=' + mvmId);
    return response;
  }

  static async getMvmLogs(mvmId: number, logTypes?: string[]) {
    let strLogTypes = "";

    logTypes?.forEach((log) => {
      strLogTypes += `&logType=${log}`;
    });

    var response = await ApiHandler(baseURL).get(`mvm/get-mvm-log?id=${mvmId}${strLogTypes}`);
    return response.data;
  }

  static async exportMvmGeneralData(plantId: string, startDate: Date | null, endDate: Date | null) {
    try {
      var response = await ApiHandler(baseURL).get(`report/ExportMvmGeneralData?plantId=${plantId}&startDate=${startDate}&endDate=${endDate}`, { responseType: 'blob' })

      let plantName = "";
      switch (plantId) {
        case '1': plantName = "fiasa"; break;
        case '2': plantName = "campolargo"; break;
        case '3': plantName = "jeep"; break;
        case '4': plantName = "mopar"; break;
        case '5': plantName = "ckd"; break;
        case '6': plantName = "faasa"; break;
        default: plantName = ""; break;
      }

      const data = new Blob([response?.data], { type: 'text/csv' });
      const txtURL = window.URL.createObjectURL(data);
      const tempLink = document.createElement('a');
      tempLink.href = txtURL;
      tempLink.setAttribute('download', `dados_ae_${plantName}_${format(new Date(), 'yyyyMMddHHmmss')}.csv`);
      tempLink.click();
    }
    catch (err: any) {
      // Como o request retornou um Blob, mensagens de erro vem em formato Blob também. Decodificar: 
      return new Promise<void>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(err?.response?.data);

        reader.onload = () => {
          const error = JSON.parse(reader.result as string);
          const errorMessage = error.message;
          if (errorMessage !== undefined && errorMessage !== "")
            reject(errorMessage)
        };
      });

    };
  }

  static async authorizeFCA(mvmId: number) {
    var response = await ApiHandler(baseURL).put(`mvm/authorize-fca/${mvmId}`);
    return response;
  }

  static async sendMvmClick() {
    var response = await ApiHandler(baseURL).get('mvmio/exportmvmclick');
    return response;
  }

  static async searchParameter(params: ParameterSearch) {
    var response = await ApiHandler(baseURL).get('mvm/parameters-search', { params });
    return response.data;
  }

  static async UpdateList(parameterPutList: any) {
    var response = await ApiHandler(baseURL).put('mvm/parameters-updatelist', parameterPutList);
    return response;
  }

  static async saveBloquedXD(bloquedXD: boolean, plantId: string) {
    var response = await ApiHandler(baseURL).put(`mvm/bloquedxd?IsBloqued=${bloquedXD}&plantId=${plantId}`);
    return response;
  }

  static async getIsBloquedXD(plantId: string) {
    var response = await ApiHandler(baseURL).get(`mvm/isBloquedxd?PlantId=${plantId}`);
    return response.data;
  }

  static async sendRequestInvoiceSAP() {
    var response = await ApiHandler(baseURL).post('sap-communication/send-sap-messages-create-mvm-outgoing-invoices');
    return response;
  }

  static async UploadFile(fileInfo: { file: any, folderName: string, fileFullName: string, originalFileName: string, name: string, contentType: string }) {
    var response = await ApiHandler(baseURL).post('s3/upload-file', fileInfo);
    return response.data;
  }

  static async DownloadFile(fileName: string, folderName: string) {
    var response = await ApiHandler(baseURL).get(`s3/download-file?fileName=${fileName}&folderPath=${folderName}`);
    return response.data;
  }

  static async DeleteFile(fileName: string, folderName: string) {
    var response = await ApiHandler(baseURL).delete(`s3/delete-file?fileName=${fileName}&folderPath=${folderName}`);
    return response.data;
  }

  static async authorizeVehicleReleasePlant(mvmId: number) {
    var response = await ApiHandler(baseURL).put(`mvm/authorize-vehicle-release-plant?mvmId=${mvmId}`);
    return response;
  }

  static async resendToSAP(id: number) {
    var response = await ApiHandler(baseURL).put(`mvm/resend-request-sap?id=${id}`);
    return response;
  }

  static async searchMDFe(params: MDFeSearch) {
    var response = await ApiHandler(baseURL).get('mvm/searchMDfe', { params });
    return response.data;
  }

  static async createMvmFromMDFe(MDFeKey: string) {
    var response = await ApiHandler(baseURL).post(`integration/CreateMvmByMDFe?MDFeKey=${MDFeKey}`);
    return response.data
  }

  static async searchOutgoingMaterialInvoice(mvmId: number) {
    var response = await ApiHandler(baseURL).get(`mvm/searchOutgoingMaterialInvoices?mvmId=${mvmId}`);
    return response.data;
  }

  static async insertOutgoingMaterialInvoice(mvmOutgoingMaterialInvoiceRequest: MvnOutgoingMaterialInvoicePost[]) {
    var response = await ApiHandler(baseURL).post(`mvm/insertOutgoingMaterialInvoice`, mvmOutgoingMaterialInvoiceRequest);
    return response.data;
  }

  static async deleteOutgoingMaterialInvoice(id: number) {
    var response = await ApiHandler(baseURL).delete(`mvm/deleteOutgoingMaterialInvoice?id=${id}`);
    return response.data;
  }

  static async searchMvmEKanban(params: MvmEKanbanSearch) {
    var response = await ApiHandler(baseURL).get('mvm/ekanban-search', { params });
    return response.data;
  }

  static async searchMvmInvoice(params: MvmInvoiceGet) {
    var response = await ApiHandler(baseURL).get('mvminvoice/search', { params });
    return response.data;
  }

  static async CreateMvmCompositionExit(cabinMvmNumber: string, cartMvmNumber: string) {
    let params = "?cabinMvmNumber=" + cabinMvmNumber + "&cartMvmNumber=" + cartMvmNumber;

    var response = await ApiHandler(baseURL).post('mvm/register-mvm-composition-exit' + params);
    return response.data;
  }


  // Concierge
  static async searchConcierge(params: ConciergeSearch) {
    var response = await ApiHandler(baseURL).get('Concierge/search', { params });
    return response.data;
  }

  static async getConcierge(conciergeId: number) {
    var response = await ApiHandler(baseURL).get(`Concierge/${conciergeId}`);
    return response.data;
  }

  static async userConcierge(user: string, plantId: number) {
    var response = await ApiHandler(baseURL).get(`/concierge/UserConcierge?user=${user}&plantId=${plantId}`);
    return response.data;
  }

  static async getUserConcierge(user: string, plantId: number) {
    var response = await ApiHandler(baseURL).get(`/concierge/getconcierge?user=${user}&plantId=${plantId}`);
    return response.data;
  }

  static async postConcierge(post: ConciergePost) {
    var response = await ApiHandler(baseURL).post('Concierge', post);
    return response.data;
  }

  static async putConcierge(concierge: ConciergePut) {
    var response = await ApiHandler(baseURL).put('Concierge', concierge);
    return response.data;
  }

  static async deleteConcierge(conciergeId: number) {
    var response = await ApiHandler(baseURL).delete(`Concierge/${conciergeId}`);
    return response.data;
  }

  static async addMvmShed(data: MvmShedAdd) {
    await ApiHandler(baseURL).post('mvm/addMvmShed', data);
  }

  static async searchPackingFCM(params: PackingFCMSearch | undefined) {
    var response = await ApiHandler(baseURL).get("packingfcm/" + "search", { params });
    return response.data;
  }

  static async postPackingFCM(packing: PackingFCMPost) {
    var response = await ApiHandler(baseURL).post("packingfcm/", packing);
    return response.data;
  }

  static async putPackingFCM(packing: PackingFCMPost) {
    var response = await ApiHandler(baseURL).put("packingfcm/", packing);
    return response.data;
  }

  static async getPackingFCM(packingFCMCode: string) {
    var response = await ApiHandler(baseURL).get(`packingfcm/${packingFCMCode}`);
    return response.data;
  }

  static async deletePackingFCM(packingFCMCode: number) {
    var response = await ApiHandler(baseURL).delete(`packingfcm/${packingFCMCode}`);
    return response.data;
  }

  static async isPackingFCM(rackTypeCode: string, companyId: number) {
    var response = await ApiHandler(baseURL).get(`packingfcm/ispackingfcm?typeCode=${rackTypeCode}&companyId=${companyId}`);
    return response.data;
  }

  static async searchConciergeMonitor(params: ConciergeMonitor) {
    var response = await ApiHandler(baseURL.replace('ae-master-mvm', 'ae-master-mvm-monitor')).get('mvm/mvm-concierge-monitor', { params });
    return response.data;
  }

  static async updateReleaseDate(id: number) {
    var response = await ApiHandler(baseURL).put('mvm/updateReleaseDate?id=' + id);
    return response.data;
  }
}
